import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { forwardRef, useImperativeHandle, useState } from "react";
import RepresentativesForm from "../components/RepresentativesForm";

const EditRepresentativesModal = forwardRef((props, ref) => {
  const [active, setActive] = useState(false);
  const [currentFather, setCurrentFather] = useState({
    id: null,
    lastname: null,
    firstname: null,
    email: null,
    phone: null,
    postal_code: null,
  });
  const [currentMother, setCurrentMother] = useState({
    id: null,
    lastname: null,
    firstname: null,
    email: null,
    phone: null,
    postal_code: null,
  });
  const [currentParentsDivorced, setCurrentParentsDivorced] = useState(false);
  const [currentContactPerson1, setCurrentContactPerson1] = useState({
    name: null,
    phone: null,
  });
  const [currentContactPerson2, setCurrentContactPerson2] = useState({
    name: null,
    phone: null,
  });

  //
  useImperativeHandle(ref, () => ({
    show: (father, mother, parentsDivorced, contactPerson1, contactPerson2) => {
      setActive(true);
      setCurrentFather({ ...father });
      setCurrentMother({ ...mother });
      setCurrentParentsDivorced(parentsDivorced);
      setCurrentContactPerson1({ ...contactPerson1 });
      setCurrentContactPerson2({ ...contactPerson2 });
    }
  }));

  const handleSubmit = () => {
    setActive(false);
    props.callbackHandler?.(currentFather, currentMother, currentParentsDivorced, currentContactPerson1, currentContactPerson2);
  };

  return (
    <>
      <Dialog
        header="Mettre à jour les responsables légaux"
        visible={active}
        onHide={() => setActive(false)}
        maximizable
        modal
        style={{ width: '90vw', height: '90vh' }}
        footer={<Button label="Enregistrer" disabled={(currentFather?.lastname && !currentFather?.email) || (currentMother?.lastname && !currentMother?.email)} icon="pi pi-save" onClick={handleSubmit} />}
      >
        <RepresentativesForm father={currentFather} mother={currentMother} parentsDivorced={currentParentsDivorced} setFather={setCurrentFather} setMother={setCurrentMother} setParentsDivorced={setCurrentParentsDivorced} contactPerson1={currentContactPerson1} contactPerson2={currentContactPerson2} setContactPerson1={setCurrentContactPerson1} setContactPerson2={setCurrentContactPerson2} />
      </Dialog>
    </>
  );
});

export default EditRepresentativesModal;